import Drawable from '../entities/Drawable.js';
import { spriteStore } from '../images.js';
import { getOSM } from '../OverworldAnimation.js';

export default class ExclamationMark extends Drawable {
    constructor({ npc }) {
        super();
        this.npc = npc;
        this.position = {
            x: npc.position.x,
            y: npc.position.y - 16,
            z: npc.position.z + 1,
        };
        this.sprite = spriteStore.store.exclamationMark;
        this.visible = false;
        this.OSM = getOSM();
    }

    spritePosition() {
        const position = this.effectivePosition();
        return position;
    }

    updatePosition() {
        this.OSM = getOSM();
        this.sprite.position.x = this.spritePosition().x;
        this.sprite.position.y = this.spritePosition().y;
        this.sprite.position.z = this.npc.position.z;
    }

    draw() {
        this.sprite.moving = true;
        this.position = {
            x: this.npc.position.x,
            y: this.npc.position.y - 24,
            z: this.npc.position.z + 1,
        };
        if (this.visible) {
            this.sprite.position = this.spritePosition();
            this.sprite.draw();
        }
    }
}
